// extracted by mini-css-extract-plugin
export default {"stepper":"UiStepper_stepper_d42X8"};